// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-selector[data-v-6801992e] {\n  max-width: 200px;\n}", ""]);
// Exports
module.exports = exports;
